import { toast as sonnerToast } from 'sonner';

const toast = sonnerToast;
export default toast;
